module.exports = __webpack_public_path__ + "img/decoration-silver-mini.e28bbf01.svg";